
import React from 'react';
import {FormFeedback} from 'reactstrap'

import { useFormikContext, getIn } from 'formik';

const MyErrorMessage = ({ name }) => {
    const formikContext = useFormikContext();
    const touched = formikContext?.touched || {};
    const errors = formikContext?.errors || {};
    const submitCount = formikContext?.submitCount || 0;

    const error = name ? getIn(errors, name) : null;
    const invalid = typeof error === 'string' && (getIn(touched, name) || submitCount > 0);
    return <FormFeedback className={invalid ? 'd-block' : null} data-error-name={name}><h5>{invalid ? error : null}</h5></FormFeedback>
   
}
export default MyErrorMessage;